import { Router, Route } from '@solidjs/router';
import Login from './pages/Login.jsx';
import Shell from './pages/Shell.jsx';

export default function App() {
  return (
    <Router>
      <Route path="/login" component={Login} />
      <Route path="*" component={Shell} />
    </Router>
  );
}
